/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

import { Card } from 'primereact/card'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Paginator } from 'primereact/paginator'

import back from '../assets/images/back.svg'


export default function ManageUserComponent({ userList, getUserByPage, totalRecords, activeUser, activeData }) {
  const [userData, setUserData] = useState([])
  const [search, setSearch] = useState('')
  const [first, setFirst] = useState(0)
  const [page, setPage] = useState(0)
  const [pageSize] = useState(10)
  const history = useHistory()

  useEffect(() => {
    getUserByPage(page, pageSize, search)
  }, [activeData])
  useEffect(() => {
    const userArray = []
    for (let i = 0; i < userList.length; i++) {
      const user = userList[i]
      userArray.push({ 'name': user.firstName + ' ' + user.lastName, 'username': user.emailAddress, 'address': user.address, 'state': user.state, 'action': '', 'userId': user.userId, 'role': user.role?.name, 'active': user.isActive })
    }
    setUserData(userArray)
  }, [userList])
  const onSearchChange = (e) => {
    const { value } = e.target
    setSearch(value)
  }
  const editUser = (id) => {
    history.push({
      pathname: '/dashboard/edit-user/' + id
    })
  }

  const activeUserById = (event, rowData) => {
    activeUser(rowData.userId, !rowData.active)
  }
  const actionTemplate = (rowData) => {
    return <div className="flex">
      {(rowData.active) ? <i className="pi pi-eye-slash m-r-10 pointer" title="De-Activate" onClick={(event) => activeUserById(event, rowData)}></i> : <i className="pi pi-eye m-r-10 pointer" title="Activate" onClick={(event) => activeUserById(event, rowData)}></i>}
      <i className="pi pi-pencil m-r-5 pointer" title="Edit User" onClick={() => { editUser(rowData.userId) }}></i>
    </div>
  }
  const onPageChange = (event) => {
    setFirst(event.first)
    setPage(event.page)
    getUserByPage(event.page, pageSize, search)
  }
  const BackClick = () => {
    history.goBack()
  }
  const onEnterKeySearch = (event) => {

    var code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      searchByName()
    }

  }
  const searchByName = () => {
    setFirst(0)
    getUserByPage(0, pageSize, search)
  }
  function AddNewUserClick() {
    history.push('/dashboard/add-user')
  }
  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <div className="titleCon m-b-20">
            <p className="title flex">
              <img src={back} alt={back} className="m-r-10 pointer" onClick={() => BackClick()} />MANAGE USERS
            </p>
            <div className="flex">
              <div className="customBtnContainer m-r-20">
                {totalRecords > 0 && <div className="pointer m-r-10" >{totalRecords} records found</div>}
                <Button icon="pi pi-plus" onClick={AddNewUserClick} className="addBtnCustom" />
                <div className="pointer m-r-10" onClick={AddNewUserClick}>Add New User</div>
              </div>
              <div className="p-inputgroup customSearch">
                <InputText placeholder="Search" value={search} onChange={onSearchChange} onKeyUp={(e) => onEnterKeySearch(e)} />
                <Button icon="pi pi-search" className="p-button-warning" onClick={() => searchByName()} />
              </div>
            </div>
          </div>
          <DataTable className="manageTableHeight" emptyMessage='No Users Found' value={userData} totalRecords={totalRecords} rows={pageSize} scrollable={true} responsive={true}>
            <Column key={'name'} field={'name'} header={'NAME'} style={{ textAlign: 'left', width: '15em' }} />
            <Column key={'username'} field={'username'} header={'USERNAME'} style={{ textAlign: 'left', width: '20em' }} />
            <Column key={'address'} field={'address'} header={'ADDRESS'} style={{ textAlign: 'left', width: '16em' }} />
            <Column key={'state'} field={'state'} header={'STATE'} style={{ textAlign: 'left', width: '10em' }} />
            <Column key={'role.name'} field={'role'} header={'ROLE'} style={{ textAlign: 'left', width: '10em' }} />
            <Column key={'action'} body={actionTemplate} style={{ textAlign: 'center', width: '8em' }} header={'ACTION'} />
          </DataTable>
          <div className="p-col-12 p-0">
            <Paginator first={first} rows={pageSize} scrollable={true} responsive={true} totalRecords={totalRecords} onPageChange={onPageChange}></Paginator>
          </div>
        </Card>
      </div>
    </div>
  )
}
ManageUserComponent.propTypes = {
  userList: PropTypes.array,
  getUserByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  activeUser: PropTypes.func,
  activeData: PropTypes.object,
}
